import { SupportCard } from 'components/SupportCard';
import { FORMATTED_DEFAULT_LOCALE } from 'constants/i18n';
import { getSupportByCountry } from 'content/support/supportByCountry';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { NextSeo } from 'next-seo';
import { getCountryFromLocaleIdentifier } from 'util/getCountryFromLocaleIdentifier';
import {
  i18nLocaleFormatter,
  isFullySupportedLocale,
} from 'util/i18nLocaleFormatter';

import styles from './style.module.scss';

const Support = () => {
  const { t } = useTranslation();

  const { locale } = useRouter();

  const supportByCountry = getSupportByCountry(t);
  const currentCountry = getCountryFromLocaleIdentifier(locale);
  const supportOptions =
    supportByCountry[
      locale && !isFullySupportedLocale(locale) ? 'eu' : currentCountry
    ];

  return (
    <>
      <NextSeo
        title="Support & FAQ"
        description="How can we help? At Feather, we're keeping insurance clear and simple and we are here to help you find the right insurance."
      />
      <div className={styles.content}>
        <div className="p-body">
          <h1 className="p-h1 p--serif ta-center">{t('page.support.title')}</h1>
          <p className="p-p ta-center mt16">{t('page.support.subtitle')}</p>
          <div className="mt64 wmx8 mx-auto">
            {supportOptions.map((country, index) => (
              <article className="mt24" key={country.title}>
                <SupportCard
                  linkType={country.linkType}
                  genericURL={country.genericURL}
                  title={country.title}
                  description={country.description}
                  imgSrc={country.imgSrc}
                  imgAlt={country.imgAlt}
                  delay={index}
                />
              </article>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(
      i18nLocaleFormatter(locale) || FORMATTED_DEFAULT_LOCALE,
      ['common']
    )),
  },
});

export default Support;
